<template>
  <div>
    <authentication-forms-container :image="image">
      <form @submit.prevent="submitForm_1">
        <h4 class="text-primary" v-t="'verify_email.title'"></h4>
        <div class="my-4">
          <m-captcha1 v-model="form_1.captcha_answer"/>
          <form-errors-manager :validation="v$.form_1.captcha_answer"/>
        </div>

        <button type="submit" class="my-3 w-100 btn btn-block btn-primary rounded-pill"
                v-t="'verify_email.button_submit'"
        >
        </button>
      </form>
    </authentication-forms-container>
  </div>
</template>
<script>
import {required, maxLength, minLength} from "@vuelidate/validators";
import FormErrorsManager from "../../validator/FormErrorsManager";
import {mapGetters} from "vuex";
import AuthenticationFormsContainer from "../Form/AuthFormsContainer";
import {useVuelidate} from "@vuelidate/core";
import mCaptcha1 from "../../Captcha/Captcha1";
import {captchaValidation} from "../../Captcha/CaptchaValidation";

export default {
  name: "VerifyEmailRequest1",
  components: {mCaptcha1, FormErrorsManager, AuthenticationFormsContainer},
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      form_step: 1,
      form_1: {
        code: "",
      },
    };
  },
  props: {
    image: {
      type: String,
      default: null
    }
  },
  validations() {
    return {
      form_1: {
        captcha_answer: captchaValidation,
      },
    }
  },
  computed: {
    ...mapGetters({
      cellphone: "User/getUserCellphone",
    }),
  },
  methods: {
    async submitForm_1() {
      const result = await this.v$.form_1.$validate()
      if (!result) return
      const form = {}
      await this.$store.dispatch("Authentication/sendEmailVerificationCode", form);
    },

  },
};
</script>
<style scoped></style>